import { PagingFilters } from "../../../components/Table/pageable-table/PagingFilters"
import { Order } from "../../../models/SortOrder"

export enum SensorInstallOrder {
    UPLOAD_DATE = "date_uploaded",
    START_DATE = "valid_start",
}

export type SensorInstallSearchFilters = {
    file_name?: string
    valid_on_date?: string
    sensor_search?: string
}

export type SensorInstallFiltersAndPaging = SensorInstallSearchFilters & PagingFilters<SensorInstallOrder>

export const sensorInstallDefaultOrderBy = SensorInstallOrder.UPLOAD_DATE
export const sensorInstallDefaultOrder = Order.desc
